export default {
  path: 'ecom',
  component: (): any => import('@/views/setting/pages/ecom/Ecom.vue'),
  meta: {
    title: 'CMS: Website E-Commerce',
    auth: true,
    icon: 'mdi-monitor',
    allowedRoles: ['SUPER_ADMIN', 'ADMIN']
  },
  children: [
    {
      path: 'banner',
      name: 'SettingBanners',
      component: (): any => import('@/views/setting/pages/ecom/pages/SettingBanners.vue'),
      meta: {
        auth: true,
        isSettingMenu: true,
        title: 'จัดการแบนเนอร์',
        allowedRoles: ['SUPER_ADMIN', 'ADMIN']
      }
    },
    {
      path: 'product',
      name: 'SettingProducts',
      component: (): any => import('@/views/setting/pages/ecom/pages/SettingProducts.vue'),
      meta: {
        auth: true,
        isSettingMenu: true,
        title: 'จัดการสินค้าหน้าเว็บไซต์',
        allowedRoles: ['SUPER_ADMIN', 'ADMIN']
      }
    },
    {
      path: 'article',
      name: 'SettingArticles',
      component: (): any => import('@/views/setting/pages/ecom/pages/articles/SettingArticles.vue'),
      meta: {
        auth: true,
        isSettingMenu: true,
        title: 'จัดการบทความ',
        allowedRoles: ['SUPER_ADMIN', 'ADMIN']
      }
    },
    {
      path: 'article-our-stores',
      name: 'SettingArticlesOurStores',
      component: (): any => import('@/views/setting/pages/ecom/pages/articles/SettingOurStores.vue'),
      meta: {
        auth: true,
        title: 'OUR STORE',
        allowedRoles: ['SUPER_ADMIN', 'ADMIN']
      }
    },
    {
      path: 'article-about',
      name: 'SettingArticlesAbout',
      component: (): any => import('@/views/setting/pages/ecom/pages/articles/SettingAbout.vue'),
      meta: {
        auth: true,
        title: 'About',
        allowedRoles: ['SUPER_ADMIN', 'ADMIN']
      }
    },
    {
      path: 'article-return-exchange',
      name: 'SettingArticlesReturnExchange',
      component: (): any => import('@/views/setting/pages/ecom/pages/articles/SettingReturnExchange.vue'),
      meta: {
        auth: true,
        title: 'RETURN & EXCHANGE',
        allowedRoles: ['SUPER_ADMIN', 'ADMIN']
      }
    },
    {
      path: 'article-privacy-policy',
      name: 'SettingArticlesPrivacyPolicy',
      component: (): any => import('@/views/setting/pages/ecom/pages/articles/SettingPrivacyPolicy.vue'),
      meta: {
        auth: true,
        title: 'Privacy Policy',
        allowedRoles: ['SUPER_ADMIN', 'ADMIN']
      }
    },
    {
      path: 'article-cookies-policy',
      name: 'SettingArticlesCookiesPolicy',
      component: (): any => import('@/views/setting/pages/ecom/pages/articles/SettingCookiesPolicy.vue'),
      meta: {
        auth: true,
        title: 'Cookies Policy',
        allowedRoles: ['SUPER_ADMIN', 'ADMIN']
      }
    }
  ]
}
